// extracted by mini-css-extract-plugin
export default {"order":"style_order__DDCuJ","orderNumber":"style_orderNumber__nvgYq","orderNumberDescription":"style_orderNumberDescription__+bSMY","image":"style_image__a0mno"};